









import { Component, Vue, Prop } from 'vue-property-decorator'
import { KBCardStructure } from '../../model/structure/KBStructure'

@Component
export default class AppKBColCard extends Vue {
  @Prop({ default: 0 }) readonly idx: number
  @Prop({ default: () => { return {} } }) readonly cardInfo: KBCardStructure
}
